import { render, staticRenderFns } from "./SimpleLoader.vue?vue&type=template&id=fbac1572&scoped=true"
var script = {}
import style0 from "./SimpleLoader.vue?vue&type=style&index=0&id=fbac1572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbac1572",
  null
  
)

export default component.exports